/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var lang_1 = require('../facade/lang');
var location_strategy_1 = require('./location_strategy');
var location_1 = require('./location');
var platform_location_1 = require('./platform_location');
var HashLocationStrategy = (function(_super) {
  __extends(HashLocationStrategy, _super);
  function HashLocationStrategy(_platformLocation, _baseHref) {
    _super.call(this);
    this._platformLocation = _platformLocation;
    this._baseHref = '';
    if (lang_1.isPresent(_baseHref)) {
      this._baseHref = _baseHref;
    }
  }
  HashLocationStrategy.prototype.onPopState = function(fn) {
    this._platformLocation.onPopState(fn);
    this._platformLocation.onHashChange(fn);
  };
  HashLocationStrategy.prototype.getBaseHref = function() {
    return this._baseHref;
  };
  HashLocationStrategy.prototype.path = function() {
    var path = this._platformLocation.hash;
    if (!lang_1.isPresent(path))
      path = '#';
    return (path.length > 0 ? path.substring(1) : path);
  };
  HashLocationStrategy.prototype.prepareExternalUrl = function(internal) {
    var url = location_1.Location.joinWithSlash(this._baseHref, internal);
    return url.length > 0 ? ('#' + url) : url;
  };
  HashLocationStrategy.prototype.pushState = function(state, title, path, queryParams) {
    var url = this.prepareExternalUrl(path + location_1.Location.normalizeQueryParams(queryParams));
    if (url.length == 0) {
      url = this._platformLocation.pathname;
    }
    this._platformLocation.pushState(state, title, url);
  };
  HashLocationStrategy.prototype.replaceState = function(state, title, path, queryParams) {
    var url = this.prepareExternalUrl(path + location_1.Location.normalizeQueryParams(queryParams));
    if (url.length == 0) {
      url = this._platformLocation.pathname;
    }
    this._platformLocation.replaceState(state, title, url);
  };
  HashLocationStrategy.prototype.forward = function() {
    this._platformLocation.forward();
  };
  HashLocationStrategy.prototype.back = function() {
    this._platformLocation.back();
  };
  HashLocationStrategy.decorators = [{type: core_1.Injectable}];
  HashLocationStrategy.ctorParameters = [{type: platform_location_1.PlatformLocation}, {
    type: undefined,
    decorators: [{type: core_1.Optional}, {
      type: core_1.Inject,
      args: [location_strategy_1.APP_BASE_HREF]
    }]
  }];
  return HashLocationStrategy;
}(location_strategy_1.LocationStrategy));
exports.HashLocationStrategy = HashLocationStrategy;
